"use client";

export default function JsonLdOrganization() {
  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Fast Track Visa",
    url: "https://fasttrackvisa.com",
    logo: "https://fasttrackvisa.com/assets/img/logo.png",
    sameAs: [
      "https://www.facebook.com/fasttrckvisa",
      "https://x.com/FTVisaServices",
      "https://www.instagram.com/fasttrackvisa/",
      "https://www.youtube.com/channel/UCUYzoyrZZ7MSEYYwu2P6-6g",
      "https://www.linkedin.com/company/fasttrack-visa-com",
    ],
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+919711610418",
        contactType: "customer service",
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(organizationJsonLd),
      }}
    />
  );
}
